/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */

export type AssetServiceLogCreateRequestCalibrationKind =
    (typeof AssetServiceLogCreateRequestCalibrationKind)[keyof typeof AssetServiceLogCreateRequestCalibrationKind];

export const AssetServiceLogCreateRequestCalibrationKind = {
    FLOW: 'FLOW',
    LEVEL: 'LEVEL',
    MAGNETOMETER: 'MAGNETOMETER',
    PUMP: 'PUMP',
    WEIGHT: 'WEIGHT'
} as const;
